/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Currentklassenstufeatbewerbungsdate4Inputs */



/**

* @param {_Field_Currentklassenstufeatbewerbungsdate4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_currentklassenstufeatbewerbungsdate4 = /** @type {((inputs?: _Field_Currentklassenstufeatbewerbungsdate4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Currentklassenstufeatbewerbungsdate4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Aktuelle Klassenstufe zum Zeitpunkt der Bewerbung")
});
export { _field_currentklassenstufeatbewerbungsdate4 as "_field_currentKlassenstufeAtBewerbungsDate" }